import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "19",
  height: "18",
  viewBox: "0 0 19 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M2.94525 10.5C3.35947 10.5 3.69525 10.8358 3.69525 11.25V14.25C3.69525 14.4489 3.77427 14.6397 3.91492 14.7803C4.05557 14.921 4.24634 15 4.44525 15H14.9453C15.1442 15 15.3349 14.921 15.4756 14.7803C15.6162 14.6397 15.6953 14.4489 15.6953 14.25V11.25C15.6953 10.8358 16.031 10.5 16.4453 10.5C16.8595 10.5 17.1953 10.8358 17.1953 11.25V14.25C17.1953 14.8467 16.9582 15.419 16.5362 15.841C16.1143 16.2629 15.542 16.5 14.9453 16.5H4.44525C3.84851 16.5 3.27622 16.2629 2.85426 15.841C2.4323 15.419 2.19525 14.8467 2.19525 14.25V11.25C2.19525 10.8358 2.53104 10.5 2.94525 10.5Z",
  fill: "#56AF40"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M10.2256 11.7803C9.93269 12.0732 9.45781 12.0732 9.16492 11.7803L5.41492 8.03033C5.12203 7.73744 5.12203 7.26256 5.41492 6.96967C5.70782 6.67678 6.18269 6.67678 6.47558 6.96967L8.94525 9.43934L8.94525 2.25C8.94525 1.83579 9.28104 1.5 9.69525 1.5C10.1095 1.5 10.4453 1.83579 10.4453 2.25L10.4453 9.43934L12.9149 6.96967C13.2078 6.67678 13.6827 6.67678 13.9756 6.96967C14.2685 7.26256 14.2685 7.73744 13.9756 8.03033L10.2256 11.7803Z",
  fill: "#56AF40"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render };